import { getDisplayName } from '../helpers';
import { addValidation } from '../Validation';

export function isPhone(msg?: string) {
  const regEx = /^[+()\d-]+$/;
  return (target: any, fieldName: string) => {
    const validation = {
      fieldName,
      validateFunction: (obj: any) => {
        const name = getDisplayName(obj, fieldName);
        const value = obj[fieldName];

        const isValid = !value || regEx.test(value);
        return isValid
          ? undefined
          : {
              message: msg || 'VM_IS_REGEX',
              data: {
                name,
                value,
              },
            };
      },
    };

    addValidation(target, fieldName, validation);
  };
}
